<template>
  <vs-popup v-if="popupActive" fullscreen :title="popupActive ? popupCampaign.title : ''" :active.sync="popupActive">
    <Loading v-if="isLoading" />
    <vs-tabs v-else position="left" class="tabs-shadow-none mt-2" id="profile-tabs" :key="isSmallerScreen">
      <vs-tab v-if="popupCampaign.hasEmail" icon-pack="feather" icon="icon-mail" :label="!isSmallerScreen ? 'Email' : ''">
        <div class="flex justify-center">
          <div class="position-relative w-full max-w-2xl" style="height: 740px">
            <iframe width="100%" height="100%" class="rounded-lg" frameBorder="0" :srcdoc="emailPreviewHtml"></iframe>
          </div>
        </div>
        <vs-row vs-justify="center" class="mt-4">
          <div class="max-w-2xl">
            <vs-row>
              <div><b>Email subject:</b></div>
              <div class="ml-2">{{ emailPreviewSubject }}</div>
            </vs-row>
            <vs-row>
              <div><b>Email send date: </b></div>
              <div class="ml-2">
                <vs-chip v-if="isDateLateForStatus(popupCampaign.sendEmailDate, popupCampaign.status)" color="danger">
                  {{ popupCampaign.sendEmailDate | formatDate }}
                </vs-chip>
                <span v-else>
                  {{ popupCampaign.sendEmailDate | formatDate }}
                </span>
              </div>
            </vs-row>
            <vs-row>
              <div><b>Email Audience estimate: </b></div>
              <vs-button size="small" v-if="queryResultEmail == -1 && !isQueryingEmail" class="ml-2" @click="getAudienceCountEmail"
                >Calculate audience</vs-button
              >
              <div v-if="isQueryingEmail" class="ml-2">
                <span class="flex h-4 w-4 mt-2">
                  <span class="animate-ping absolute inline-flex h-4 w-4 rounded-full bg-primary opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-4 w-4 bg-primary"></span>
                </span>
              </div>
              <div v-if="queryResultEmail != -1 && !isQueryingEmail" class="ml-2 flex items-center">
                <span class="ml-2">{{ queryResultEmail }}</span>
                <feather-icon class="ml-1" icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
            </vs-row>
          </div>
        </vs-row>
      </vs-tab>
      <vs-tab v-if="popupCampaign.hasSms" icon-pack="feather" icon="icon-smartphone" :label="!isSmallerScreen ? 'Sms' : ''">
        <div class="flex justify-center">
          <div class="w-full max-w-2xl">
            <vs-row vs-justify="center" class="mb-2">
              <h4>Sms</h4>
            </vs-row>
            <div class="px-5">
              <vs-textarea class="smsContentContainer" :readonly="true" height="300px" v-model="smsPreviewContent" counter="160" />
            </div>
          </div>
        </div>
        <vs-row vs-justify="center" class="mt-4">
          <div class="max-w-2xl">
            <vs-row>
              <div><b>Estimtated SMS count per guest:</b></div>
              <div class="ml-2">
                {{ Math.floor(smsPreviewContent.length / 160) + 1 }}
              </div>
            </vs-row>
            <vs-row>
              <div><b>SMS send date: </b></div>
              <div class="ml-2">
                <vs-chip v-if="isDateLateForStatus(popupCampaign.sendSmsDate, popupCampaign.status)" color="danger">
                  {{ popupCampaign.sendSmsDate | formatDate }}
                </vs-chip>
                <span v-else>
                  {{ popupCampaign.sendSmsDate | formatDate }}
                </span>
              </div>
            </vs-row>
            <vs-row>
              <div><b>Sms Audience estimate: </b></div>
              <vs-button size="small" v-if="queryResultSms == -1 && !isQueryingSms" class="ml-2" @click="getAudienceCountSms"
                >Calculate audience</vs-button
              >
              <div v-if="isQueryingSms" class="ml-2">
                <span class="flex h-4 w-4 mt-2">
                  <span class="animate-ping absolute inline-flex h-4 w-4 rounded-full bg-primary opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-4 w-4 bg-primary"></span>
                </span>
              </div>
              <div v-if="queryResultSms != -1 && !isQueryingSms" class="ml-2 flex items-center">
                <span class="ml-2">{{ queryResultSms }}</span>
                <feather-icon class="ml-1" icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
            </vs-row>
          </div>
        </vs-row>
      </vs-tab>
      <vs-tab v-if="popupCampaign.hasNpPush" icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'NightPay Push' : ''">
        <div class="flex justify-center">
          <div class="w-full max-w-2xl">
            <vs-row vs-justify="center" class="mb-2">
              <h4>NightPay Push</h4>
            </vs-row>
            <div class="px-5">
              <div class="pb-2">
                <vs-textarea
                  label="Title"
                  class="npPushContentContainer mt-2"
                  :readonly="true"
                  height="80px"
                  v-model="npPushPreviewTitle"
                  counter="65"
                />
              </div>

              <div>
                <vs-textarea
                  label="Body"
                  class="npPushContentContainer"
                  :readonly="true"
                  height="180px"
                  v-model="npPushPreviewBody"
                  counter="178"
                />
              </div>

              <div>
                <vs-input label="CTA name" class="npPushContentContainer w-full mb-4" :readonly="true" v-model="npPushPreviewCtaName" />
              </div>
              <div>
                <vs-input label="CTA url" class="npPushContentContainer w-full mb-4" :readonly="true" v-model="npPushPreviewCtaUrl" />
              </div>
            </div>
          </div>
        </div>
        <vs-row vs-justify="center" class="mt-4">
          <div class="max-w-2xl">
            <vs-row>
              <div><b>Push message send date: </b></div>
              <div class="ml-2">
                <vs-chip v-if="isDateLateForStatus(popupCampaign.sendNpPushDate, popupCampaign.status)" color="danger">
                  {{ popupCampaign.sendNpPushDate | formatDate }}
                </vs-chip>
                <span v-else>
                  {{ popupCampaign.sendNpPushDate | formatDate }}
                </span>
              </div>
            </vs-row>
            <vs-row>
              <div><b>Push message audience estimate: </b></div>
              <vs-button size="small" v-if="queryResultNpPush == -1 && !isQueryingNpPush" class="ml-2" @click="getAudienceCountNpPush"
                >Calculate audience</vs-button
              >
              <div v-if="isQueryingNpPush" class="ml-2">
                <span class="flex h-4 w-4 mt-2">
                  <span class="animate-ping absolute inline-flex h-4 w-4 rounded-full bg-primary opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-4 w-4 bg-primary"></span>
                </span>
              </div>
              <div v-if="queryResultNpPush != -1 && !isQueryingNpPush" class="ml-2 flex items-center">
                <span class="ml-2">{{ queryResultNpPush }}</span>
                <feather-icon class="ml-1" icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
              </div>
            </vs-row>
          </div>
        </vs-row>
      </vs-tab>
      <!-- <vs-tab
        v-if="popupCampaign.hasSms"
        icon-pack="feather"
        icon="icon-smartphone"
        :label="!isSmallerScreen ? 'Action log' : ''"
      >
      </vs-tab> -->
    </vs-tabs>

    <vs-divider />

    <vs-row vs-justify="center">
      <vs-col :vs-w="6" class="p-4">
        <venue-campaign-action-log :venueCampaign="popupCampaign" />
      </vs-col>
      <vs-col :vs-w="6" class="p-4" v-if="showActiveRejectButtons">
        <vx-card title="Approve or deny">
          <vs-row v-if="isCampaignLate">NB: Cannot approve campaign as a send date has been exceeded</vs-row>
          <vs-row vs-justify="center" class="my-5">
            <vs-button
              class="mr-2 py-6 w-48"
              :color="popupAction == 0 ? 'green' : 'grey'"
              :disabled="isCampaignLate"
              @click="popupAction = 0"
            >
              <feather-icon icon="CheckCircleIcon" />
              <br />
              Approve
            </vs-button>
            <vs-button class="py-6 w-48" :color="popupAction == 1 ? 'danger' : 'grey'" @click="popupAction = 1">
              <feather-icon icon="XCircleIcon" />
              <br />
              Reject
            </vs-button>
          </vs-row>
          <vs-row vs-justify="center">
            <vs-col vs-w="10">
              <div v-if="popupAction == 0 && !popupCampaign.isBasedOnMasterCampaign" class="pb-4">
                <b>Approving a Venue created campaign will allow it to be sent at the specified dates.</b>
                The campaign will be locked for further editing, unless it is subsequently rejected prior to being sent.
              </div>
              <vs-textarea
                v-if="popupAction != null"
                :label="popupAction == 0 ? 'Approve reason' : 'Reject reason'"
                :placeholder="
                  popupAction == 0
                    ? 'Specify the reason for approving (optional)'
                    : 'Specify the reason for rejecting. This will make it easier for the receiver to correct the potential issues.'
                "
                v-model="comment"
              />
            </vs-col>
          </vs-row>
          <vs-row vs-justify="center" class="my-5">
            <vs-button
              v-if="popupAction != null"
              class="py-6"
              :disabled="popupAction == null || (popupAction == 1 && comment == '')"
              color="primary"
              @click="onPopupSubmit"
              >Submit {{ this.popupAction == 0 ? "Approval" : "Rejection" }}</vs-button
            >
          </vs-row>
        </vx-card>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";
import VenueCampaignActionLog from "@/views/modules/vp/venueCampaigns/Components/VenueCampaignActionLog.vue";
import { DatePicker } from "v-calendar";
import moment from "moment";

export default {
  components: {
    DatePicker,
    VenueCampaignActionLog
  },
  data() {
    return {
      isHQPopup: false,

      popupActive: false,
      popupCampaign: null,
      popupAction: null,
      masterCampaign: null,

      isQueryingEmail: false,
      queryResultEmail: -1,

      isQueryingSms: false,
      queryResultSms: -1,

      isQueryingNpPush: false,
      queryResultNpPush: -1,

      comment: "",

      isLoading: true,

      calendarAttributes: [
        {
          key: "today",
          highlight: "gray"
        }
      ]
    };
  },
  methods: {
    async show(campaign, masterCampaign, isHQPopup) {
      this.popupCampaign = campaign;
      this.masterCampaign = masterCampaign;
      this.popupAction = null;
      this.comment = "";
      this.popupActive = true;

      this.isQueryingEmail = false;
      this.queryResultEmail = -1;

      this.isQueryingSms = false;
      this.queryResultSms = -1;

      this.isQueryingNpPush = false;
      this.queryResultNpPush = -1;

      this.isHQPopup = isHQPopup;

      this.isLoading = true;
      await this.$store.dispatch("venueCampaigns/getPreviewHtml", this.popupCampaign.id);
      this.isLoading = false;
    },
    isDateLateForStatus(date, status) {
      return (status == "SubmittedForApproval" || status == "Rejected") && moment(date).isBefore(moment());
    },
    async getAudienceCountEmail() {
      console.log("Submitted audience query EMAIL", this.popupCampaign.emailGuestQuery);
      this.isQueryingEmail = true;
      const result = await this.$store.dispatch("userProfiles/getCountByGuestQuery", this.popupCampaign.emailGuestQuery);
      this.queryResultEmail = result;
      this.isQueryingEmail = false;
    },
    async getAudienceCountSms() {
      console.log("Submitted audience query SMS", this.popupCampaign.smsGuestQuery);
      this.isQueryingSms = true;
      const result = await this.$store.dispatch("userProfiles/getCountByGuestQuery", this.popupCampaign.smsGuestQuery);
      this.queryResultSms = result;
      this.isQueryingSms = false;
    },
    async getAudienceCountNpPush() {
      console.log("Submitted audience query NP PUSH", this.popupCampaign.npPushGuestQuery);
      this.isQueryingNpPush = true;
      const result = await this.$store.dispatch("userProfiles/getCountByGuestQuery", this.popupCampaign.npPushGuestQuery);
      console.log("Query done");
      this.queryResultNpPush = result;
      this.isQueryingNpPush = false;
    },
    async onPopupSubmit() {
      let action = "";
      if (this.popupAction == 0) action = "approved";
      if (this.popupAction == 1) action = "rejected";
      try {
        if (this.popupAction == 0) {
          // Approve
          await this.$store.dispatch("venueCampaigns/approve", {
            venueCampaign: this.popupCampaign,
            comment: this.comment
          });
        } else if (this.popupAction == 1) {
          await this.$store.dispatch("venueCampaigns/reject", {
            venueCampaign: this.popupCampaign,
            comment: this.comment
          });
        }

        this.$vs.notify({
          color: "green",
          title: "Campaign " + action,
          text: "The campaign was successfully " + action
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Campaign could not be " + action,
          text: err
        });
      } finally {
        this.$vs.loading.close();
        this.popupActive = false;
        this.popupAction = null;
        this.popupCampaign = null;
        this.masterCampaign = null;

        this.$emit("onSubmit");
      }
    }
  },
  computed: {
    ...mapGetters({
      emailPreviewSubject: "venueCampaigns/emailPreviewSubject",
      emailPreviewHtml: "venueCampaigns/emailPreviewHtml",
      smsPreviewContent: "venueCampaigns/smsPreviewContent",
      npPushPreviewTitle: "venueCampaigns/npPushPreviewTitle",
      npPushPreviewBody: "venueCampaigns/npPushPreviewBody",
      npPushPreviewCtaName: "venueCampaigns/npPushPreviewCtaName",
      npPushPreviewCtaUrl: "venueCampaigns/npPushPreviewCtaUrl"
    }),
    isCampaignLate() {
      return (
        this.isDateLateForStatus(this.popupCampaign.sendSmsDate, this.popupCampaign.status) ||
        this.isDateLateForStatus(this.popupCampaign.sendEmailDate, this.popupCampaign.status)
      );
    },
    showActiveRejectButtons() {
      // Note that vm.crm.campaigns.edit is actually a global permission
      if (!this.hasPermissionForEntity("vp.crm.campaigns.edit", this.popupCampaign.venueId)) return false;

      if (!this.isHQPopup) return false;

      if (!this.popupCampaign.isBasedOnMasterCampaign || !this.masterCampaign) return this.popupCampaign.status == "SubmittedForApproval";

      return this.masterCampaign.masterStatus == "Active" && this.popupCampaign.status == "SubmittedForApproval";
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    }
  }
};
</script>

<style lang="scss">
.smsContentContainer textarea,
.npPushContentContainer textarea {
  height: 100%;
}
</style>